import React from "react";
import { Modal } from "react-bootstrap";

type Props = {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmActionModal = ({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  onConfirm,
  onCancel,
}: Props) => (
  <Modal show onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: 17, fontWeight: 600 }}>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p style={{ margin: 0 }}>{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <button className="RT-Button RT-Button--cancel" onClick={onCancel}>
        {cancelLabel}
      </button>
      <button
        className={`RT-Button ${danger ? "RT-Button--destructive" : "RT-Button--primary"}`}
        onClick={onConfirm}
      >
        {confirmLabel}
      </button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmActionModal;
